import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";

import { ButtonComponent, PageComponent } from "@shared/components";
import { PlanTableComponent } from "@shared/components";
import { GlobalService } from "@shared/services";

@Component({
  selector: "app-standby-plan",
  standalone: true,
  imports: [PageComponent, PlanTableComponent, ButtonComponent],
  templateUrl: "./standby-plan.component.html",
  styleUrl: "./standby-plan.component.scss",
})
export class StandbyPlanComponent {
  globalService = inject(GlobalService);
  router = inject(Router);

  onOptionsPress(): void {
    this.router.navigate(["/standbyoptions"]);
  }
}
